/*!
 * jQuery capslockstate plugin (modernized)
 * Inspiration: https://github.com/nosilleg/capslockstate-jquery-plugin
 * Uses KeyboardEvent.getModifierState('CapsLock')
 */
(function ($) {
    var capsLockState = 'unknown';

    var helpers = {
        fromEvent: function (e) {
            var oe = e && (e.originalEvent || e);
            if (oe && typeof oe.getModifierState === 'function') {
                var v = oe.getModifierState('CapsLock');
                return (v === true || v === false) ? v : 'unknown';
            }
            return 'unknown';
        },
        hasStateChange: function (prev, curr) {
            if (prev === curr) return;
            $('body').trigger('capsChanged');
            if (curr === true) $('body').trigger('capsOn');
            else if (curr === false) $('body').trigger('capsOff');
            else $('body').trigger('capsUnknown');
        }
    };

    var methods = {
        init: function () {
            // Update on any keydown/keyup anywhere (window-level monitoring remains)
            $('body')
                .on('keydown.capslockstate keyup.capslockstate', function (e) {
                    var prev = capsLockState;
                    var curr = helpers.fromEvent(e);
                    // If still unknown and key is CapsLock, toggle from known state
                    if (curr === 'unknown' && (e.key === 'CapsLock' || e.which === 20)) {
                        if (capsLockState !== 'unknown') curr = !capsLockState;
                    }
                    if (curr !== 'unknown' || capsLockState !== 'unknown') {
                        if (curr === 'unknown') curr = capsLockState; // no change
                    }
                    if (curr !== capsLockState) {
                        capsLockState = curr;
                        helpers.hasStateChange(prev, capsLockState);
                    }
                });

            // When window focus changes, clear to unknown
            $(window).on('blur.capslockstate focus.capslockstate', function () {
                var prev = capsLockState;
                capsLockState = 'unknown';
                helpers.hasStateChange(prev, capsLockState);
            });

            // Initial fire
            helpers.hasStateChange(null, 'unknown');
            return this;
        },
        state: function () { return capsLockState; },
        destroy: function () {
            $('body').off('.capslockstate');
            $(window).off('.capslockstate');
            return this;
        }
    };

    $.fn.capslockstate = function (method) {
        if (methods[method]) return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        if (typeof method === 'object' || !method) return methods.init.apply(this, arguments);
        $.error('Method ' + method + ' does not exist on jQuery.capslockstate');
    };
})(jQuery);
